export const HOME = "/";
export const PASSENGERS = "/passengers";
export const DRIVERS = "/drivers";
//export const SECURITY = "/security";
export const QUESTIONS = "/faq";
export const TERMS = "/terms";
